module.exports = __webpack_public_path__ + "media/images/lb/083-56cbb6ca4e8556228eeddfd5b82142e4.svg";